import React from "react";
import { useSelector } from "react-redux";
import { selectShipLoose } from "../../../redux/selectors";

const PrintShipLoose = () => {
  const shipLooseDetails = useSelector(selectShipLoose);

  const getHasShipLooseValue = (detail) => {
    const rawValue = detail?.HasShipLoose ?? detail?.hasShipLoose;

    if (typeof rawValue === "string") {
      const normalizedValue = rawValue.trim().toLowerCase();
      if (normalizedValue === "true") return true;
      if (normalizedValue === "false") return false;
    }

    if (typeof rawValue === "number") {
      if (rawValue === 1) return true;
      if (rawValue === 0) return false;
    }

    if (typeof rawValue === "boolean") {
      return rawValue;
    }

    return null;
  };

  const hasAnyShipLooseFalse =
    Array.isArray(shipLooseDetails) &&
    shipLooseDetails.some((detail) => getHasShipLooseValue(detail) === false);

  const isZoneEmpty = (detail) => {
    return (
      !detail.Title &&
      !detail.Quantity &&
      !detail.Description
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];

          if (
            zoneDetails.every(
              (detail) => getHasShipLooseValue(detail) !== true || isZoneEmpty(detail)
            )
          ) {
            return null;
          }

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Quantity</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (getHasShipLooseValue(detail) !== true || isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td>{detail.Title}</td>
                        <td>{detail.Quantity}</td>
                        <td>{detail.Description}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  if (hasAnyShipLooseFalse) {
    return null;
  }

  return (
    <div>
      {Array.isArray(shipLooseDetails) &&
        shipLooseDetails.some((detail) => getHasShipLooseValue(detail) === true) && (
        <h2 className="print-section-header">Ship Loose Summary</h2>
      )}
      {renderDetails(shipLooseDetails)}
    </div>
  );
};

export default PrintShipLoose;
